import { Add, Visibility, NextWeek } from "@mui/icons-material";
import { Pagination } from "@mui/material";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import ButtonGeneric from "../../components/ButtonGeneric";
import { CompleteFilter } from "../../components/CompleteFilter";
import { applyClientFilters } from "../../components/CompleteFilter/applyClientFilters";
import { If } from "../../components/If";
import { PageDefault } from "../../components/PageDefault";
import PageWrapper from "../../components/PageWrapper/index";
import TableDataGrid from "../../components/TableDataGrid";
import { useAuth } from "../../contexts/contexts";
import { defaultToast } from "../../helpers/toast/defaultToast";
import { api } from "../../services/api";
import { ContentTable, ContentPagination } from "./styles";

export interface IManagerDatabasesProps {
    id: number;
    cluster_name: string;
    public_host: string;
    private_host: string;
    customer_database_type_id: number;
    database_type: {
        id: string;
        name: string;
    };
    cloud: string;
}

let last_page: number | null = null;

function ManagerDatabasePage() {
    const navigate = useNavigate();
    const { hasPermissions, permissions } = useAuth();
    useEffect(() => {
        if (
            !hasPermissions("configuracoes.visualizar_gerenciamento_banco") &&
            permissions.length > 0
        ) {
            navigate("/Error");
        }
    }, [permissions]);
    const [loadingTable, setLoadingTable] = useState(true);
    const [queryFilter, setQueryFilter] = useState("");
    const [managerDatabases, setManagerDatabases] = useState<
        IManagerDatabasesProps[]
    >([]);

    const getListDatabases = async (currentPage = 1) => {
        try {
            setLoadingTable(true);
            const responseListDatabase = await api.get(
                `/clustersDatabases?page=${currentPage}`
            );

            if (responseListDatabase?.status) {
                last_page = responseListDatabase?.data?.response?.last_page;
                setManagerDatabases(
                    responseListDatabase?.data?.response?.data ?? []
                );
            }
        } catch (error) {
            console.error(error);
            defaultToast("error", "Erro ao listar bancos");
            window.location.reload();
        } finally {
            setLoadingTable(false);
        }
    };

    useEffect(() => {
        getListDatabases();
    }, []);

    const filteredRows = applyClientFilters(
        managerDatabases as unknown as Record<string, unknown>[],
        queryFilter,
        {
            textFields: [
                "cluster_name",
                "public_host",
                "private_host",
                "cloud",
            ],
        }
    ) as unknown as IManagerDatabasesProps[];

    const columns: GridColDef[] = [
        {
            field: "id",
            headerName: "ID",
            flex: 5,
        },
        {
            field: "cluster_name",
            headerName: "Nome Cluster",
            flex: 12,
        },
        {
            field: "public_host",
            headerName: "Host Público",
            align: "center",
            flex: 12,
        },
        {
            field: "private_host",
            headerName: "Host Privado",
            flex: 12,
        },
        {
            field: "database_type",
            headerName: "Tipo",
            flex: 12,
            renderCell: (params: GridRenderCellParams) => (
                <div>
                    {String(
                        params?.row?.database_type?.name
                    ).toLocaleUpperCase()}
                </div>
            ),
        },
        {
            field: "cloud",
            headerName: "Cloud",
            flex: 12,
            renderCell: (params: GridRenderCellParams) => (
                <div>{String(params?.row?.cloud).toLocaleUpperCase()}</div>
            ),
        },
        {
            field: "ações",
            headerName: "Ações",
            sortable: false,
            align: "right",
            headerAlign: "right",
            flex: 12,
            renderCell: (params: GridRenderCellParams) => (
                <div className="containerActionButtonsListTablePagesGlobal">
                    <If
                        condition={hasPermissions(
                            "configuracoes.criar_gerenciamento_banco"
                        )}
                    >
                        <Visibility
                            className="cursorPointerGlobal"
                            onClick={() => {
                                navigate(
                                    `/settings/manager-databases/details-database?id=${params.id}`
                                );
                            }}
                        />
                    </If>

                    {/* <If condition={hasPermissions("propostas.excluir")}>
                        <Delete
                            className="cursorPointerGlobal"
                            onClick={() => {
                                setOpenModalDeleteDatabase(true);
                            }}
                        />
                    </If> */}
                </div>
            ),
        },
    ];

    return (
        <PageWrapper>
            <PageDefault
                headerPage
                header={{
                    title: "Banco de dados",
                    subtitle: "Lista banco de dados",
                    icon: <NextWeek sx={{ color: "#fff" }} />,
                }}
            >
                <div className="containerListTablePagesGlobal">
                    <CompleteFilter
                        fields={[
                            { value: "cluster_name", label: "Nome Cluster" },
                            { value: "public_host", label: "Host Público" },
                            { value: "private_host", label: "Host Privado" },
                            { value: "cloud", label: "Cloud" },
                        ]}
                        onSearch={setQueryFilter}
                        actions={
                            <If
                                condition={hasPermissions(
                                    "configuracoes.criar_gerenciamento_banco"
                                )}
                            >
                                <ButtonGeneric
                                    onclick={() => {
                                        navigate(
                                            "/settings/manager-databases/new-database"
                                        );
                                    }}
                                    buttonColor="var(--secondary)"
                                    text="Criar Novo Banco"
                                    icon={<Add />}
                                />
                            </If>
                        }
                    />
                    <ContentTable>
                        <TableDataGrid
                            style={{ minWidth: "460px !important" }}
                            rows={filteredRows}
                            columns={columns}
                            loading={loadingTable}
                            hideFooterPagination
                        />
                    </ContentTable>
                    <ContentPagination>
                        <Pagination
                            color="primary"
                            count={last_page as number}
                            onChange={(event: any) =>
                                getListDatabases(
                                    Number(event.target.textContent)
                                )
                            }
                            hideNextButton
                            hidePrevButton
                        />
                    </ContentPagination>
                    {/* <ModalDeleteDatabase
                            openModalDeleteDatabase={openModalDeleteDatabase}
                            handleCloseModalDeleteDatabase={
                                handleCloseModalDeleteDatabase
                            }
                            selectedRowProposal={selectedRowProposal}
                            dataProposalsList={managerDatabases}
                            setDataProposalsList={setManagerDatabases}
                        /> */}
                </div>
            </PageDefault>
        </PageWrapper>
    );
}
export default ManagerDatabasePage;
